// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9z-4";
export var collapsed = "_9z-1";
export var headerBar = "_9z-0";
export var leftHeaderContent = "_9z-3";
export var subjectContainer = "_9z-2";